/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/range_min.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the minimum (start) value of a range. For a range [x, y), it returns x.
 *
 * @example
 * FROM decades
 * | WHERE decade == 1900
 * | EVAL min_bound = RANGE_MIN(date_range)
 * | KEEP date_range, min_bound
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'range_min',
  signatures: [
    {
      params: [
        {
          name: 'range',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'range',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
